import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let geoCache = null;

export const getGeolocation = async () => {
  if (geoCache) return geoCache;
  try {
    const response = await axios.get('https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation');
    if (response.data?.isSuccess) {
      geoCache = response.data;
    }
    return response.data;
  } catch (error) {
    console.error('Geolocation error:', error);
    return null;
  }
};

export const submitLead = async (formData) => {
  try {
    const geo = geoCache || await getGeolocation();
    const payload = {
      name: formData.name,
      email: formData.email,
      countryDialCode: parseInt(formData.countryDialCode) || 1,
      country: formData.countryCode || '',
      phoneNumber: formData.phoneNumber,
      ipAddress: geo?.data?.ipAddress || '',
      description: formData.message || '',
      pageUrl: window.location.href,
      city: geo?.data?.cityName || '',
      state: geo?.data?.regionName || '',
      geoLocation: geo ? JSON.stringify(geo) : '',
      packageTitle: formData.packageTitle || '',
      packageAmount: formData.packageAmount || 0,
      tmSignUpType: formData.tmSignUpType || 1,
    };

    const response = await axios.post('https://leadapi.crmbytes.com/api/Lead/AddLead', payload);
    return { status: response.status, data: response.data };
  } catch (error) {
    if (error.response) {
      return { status: error.response.status, data: error.response.data };
    }
    throw error;
  }
};

export const getGeoCache = () => geoCache;
